module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Moosleerau_AG-be465316d01cb55270afef9cf05efe63.svg";